/* Jalecos Mania — integridade de grupos no carrinho.
   Uma peça personalizada e seus serviços de bordado são linhas distintas no
   Shopify, mas formam uma única unidade comercial. Este módulo altera/remover
   o grupo em uma única chamada, usando as chaves estáveis das linhas. */
(function () {
  function propertiesOf(item) {
    return (item && item.properties) || {};
  }

  function roleOf(item) {
    return String(propertiesOf(item)._jm_role || '').toLowerCase();
  }

  function groupOf(item) {
    return String(propertiesOf(item)._jm_codigo || '');
  }

  function isAddon(item) {
    if (roleOf(item) === 'addon') return true;
    var title = String((item && item.product_title) || '').toLowerCase();
    return /^bordado\s+de\s+/.test(title) && !!propertiesOf(item).Produto;
  }

  function findItem(cart, options) {
    var items = (cart && cart.items) || [];
    if (options.key) {
      var byKey = items.find(function (item) { return item.key === options.key; });
      if (byKey) return byKey;
    }
    return items[Math.max(0, Number(options.line || 1) - 1)] || null;
  }

  function legacyAddonsFor(items, parent) {
    var props = propertiesOf(parent);
    if (!props['Personalização']) return [];
    var parentTitle = String(parent.product_title || '').trim().toLowerCase();
    return items.filter(function (item) {
      return item !== parent && isAddon(item) &&
        String(propertiesOf(item).Produto || '').trim().toLowerCase() === parentTitle;
    });
  }

  function groupedItems(cart, target) {
    var items = (cart && cart.items) || [];
    var group = groupOf(target);
    if (roleOf(target) === 'addon' || isAddon(target)) {
      if (group) {
        var grouped = items.filter(function (item) { return groupOf(item) === group; });
        var hasGroupedParent = grouped.some(function (item) { return !isAddon(item); });
        return hasGroupedParent ? [target] : grouped;
      }

      // Limpa de uma vez os add-ons antigos que já ficaram órfãos no carrinho.
      var productName = String(propertiesOf(target).Produto || '').trim().toLowerCase();
      var hasLegacyParent = items.some(function (item) {
        return !isAddon(item) && !!propertiesOf(item)['Personalização'] &&
          String(item.product_title || '').trim().toLowerCase() === productName;
      });
      if (!hasLegacyParent && productName) {
        return items.filter(function (item) {
          return isAddon(item) &&
            String(propertiesOf(item).Produto || '').trim().toLowerCase() === productName;
        });
      }
      return [target];
    }
    if (group) {
      return items.filter(function (item) { return groupOf(item) === group; });
    }
    // Compatibilidade com personalizações criadas antes do código de grupo.
    return [target].concat(legacyAddonsFor(items, target));
  }

  function updateRequest(cart, target, quantity, options) {
    var updates = {};
    groupedItems(cart, target).forEach(function (item) {
      updates[item.key] = Number(quantity);
    });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: options.sectionId,
        sections_url: options.sectionsUrl || '/',
      }),
    }).then(function (response) {
      if (!response.ok) throw new Error('cart-group-update-failed');
      return response.json();
    });
  }

  function change(options) {
    options = options || {};
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart-read-failed');
        return response.json();
      })
      .then(function (cart) {
        var target = findItem(cart, options);
        if (!target) throw new Error('cart-line-not-found');
        return updateRequest(cart, target, options.quantity, options);
      });
  }

  function visibleCount(cart) {
    return ((cart && cart.items) || []).reduce(function (total, item) {
      return total + (isAddon(item) ? 0 : Number(item.quantity || 0));
    }, 0);
  }

  window.JMCartGroups = {
    change: change,
    visibleCount: visibleCount,
  };
})();
